export default __webpack_public_path__ + "static/media/preview.fcc1d166.jpg";